<script>
import { Bar, mixins } from "vue-chartjs";

const { reactiveProp } = mixins;

export default {
  name: "DailyCasesChart",
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: "Cases per Day",
            backgroundColor: "lightgreen",
            data: this.chartData
          }
        ]
      },
      {
        title: {
          display: true,
          text: "Daily Cases for Last 7 Days"
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    );
  }
};
</script>
